import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight, Filter } from "lucide-react";
import Navbar from "@/components/campus/Navbar";
import Footer from "@/components/campus/Footer";
import { api } from "@/lib/api";

export default function Colleges() {
  const [items, setItems] = useState([]);
  const [filters, setFilters] = useState({ state: "", stream: "", college_type: "" });

  useEffect(() => {
    const params = {};
    if (filters.state) params.state = filters.state;
    if (filters.stream) params.stream = filters.stream;
    if (filters.college_type) params.college_type = filters.college_type;
    api.listColleges(params).then(setItems).catch(()=>{});
  }, [filters]);

  return (
    <div className="min-h-screen bg-[#0F172A] text-white">
      <Navbar/>
      <section className="pt-28 pb-12 px-6 md:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="text-xs font-bold tracking-[0.25em] uppercase text-[#60A5FA]">Browse</div>
          <h1 className="font-display text-4xl md:text-5xl font-bold mt-2">Explore Colleges</h1>
          <p className="text-slate-400 mt-3 max-w-2xl">Find verified Campus Ambassadors at top Indian colleges.</p>

          <div className="glass rounded-2xl p-4 mt-8 flex flex-wrap gap-3 items-center">
            <Filter size={16} className="text-slate-400"/>
            <select data-testid="filter-state" value={filters.state} onChange={(e)=>setFilters({...filters, state:e.target.value})} className="bg-[#1E293B] border border-white/10 rounded-lg px-3 py-2 text-sm">
              <option value="">All States</option>
              {["Haryana","Rajasthan","Odisha","Chhattisgarh","West Bengal","Karnataka","Maharashtra","Delhi","Tamil Nadu","Uttar Pradesh"].map(s=><option key={s}>{s}</option>)}
            </select>
            <select data-testid="filter-stream" value={filters.stream} onChange={(e)=>setFilters({...filters, stream:e.target.value})} className="bg-[#1E293B] border border-white/10 rounded-lg px-3 py-2 text-sm">
              <option value="">All Streams</option>
              {["Engineering","Medical","Management","Law","Pharmacy","Science","MBA","MCA"].map(s=><option key={s}>{s}</option>)}
            </select>
            <select data-testid="filter-type" value={filters.college_type} onChange={(e)=>setFilters({...filters, college_type:e.target.value})} className="bg-[#1E293B] border border-white/10 rounded-lg px-3 py-2 text-sm">
              <option value="">All Types</option>
              <option value="govt">Government</option>
              <option value="private">Private</option>
              <option value="deemed">Deemed</option>
            </select>
            <button data-testid="filter-clear" onClick={()=>setFilters({state:"",stream:"",college_type:""})} className="text-xs text-slate-400 hover:text-white ml-auto">Clear Filters</button>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
            {items.map((c)=>(
              <Link key={c.slug} to={`/college/${c.slug}`} data-testid={`college-${c.slug}`} className="glass rounded-2xl p-5 hover:-translate-y-1 hover:border-[#2563EB]/50 transition">
                <div className="flex gap-4">
                  <div className="w-20 h-20 rounded-xl bg-gradient-to-br from-[#2563EB] to-[#1E3A8A] text-white flex items-center justify-center font-display font-bold text-2xl shrink-0">{c.name.split(" ").map(w=>w[0]).slice(0,2).join("")}</div>
                  <div className="flex-1 min-w-0">
                    <div className="font-display font-bold text-lg text-white truncate">{c.name}</div>
                    <div className="text-sm text-slate-400 flex items-center gap-1 mt-0.5"><MapPin size={12}/>{c.city}, {c.state}</div>
                    <div className="flex flex-wrap gap-1 mt-2">
                      {c.naac_grade && <span className="text-[10px] px-2 py-0.5 rounded-full bg-emerald-500/15 text-emerald-300 font-semibold">NAAC {c.naac_grade}</span>}
                      <span className="text-[10px] px-2 py-0.5 rounded-full bg-blue-500/15 text-blue-300 font-semibold capitalize">{c.college_type}</span>
                    </div>
                  </div>
                </div>
                <div className="flex flex-wrap gap-1 mt-3">
                  {(c.streams || []).slice(0,3).map((s)=> <span key={s} className="text-xs px-2 py-0.5 rounded-full bg-white/5 border border-white/10 text-slate-300">{s}</span>)}
                </div>
                <div className="mt-4 flex items-center justify-between text-sm">
                  <span className="text-slate-400">{c.ambassador_count || 0} Campus Ambassadors</span>
                  <span className="text-[#60A5FA] font-semibold inline-flex items-center gap-1">Explore <ArrowRight size={14}/></span>
                </div>
              </Link>
            ))}
          </div>
          {items.length === 0 && <div className="text-center text-slate-400 py-24">No colleges match these filters.</div>}
        </div>
      </section>
      <Footer/>
    </div>
  );
}
